export default __webpack_public_path__ + "static/media/payment-enterprise.6ab81a65.svg";